module.exports = __webpack_public_path__ + "static/media/ChildrenSelected.a172997b.png";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/onboardig/ChildrenSelected.png
// module id = 3832
// module chunks = 0